import { Outlet, Link, useLocation } from "react-router";
import { useSnapshot } from "valtio";
import { analyticsStore, setTimeRange } from "../stores/analytics";
import { cn } from "@/lib/utils";

const navItems = [
  { label: "Overview", path: "/analytics" },
  { label: "Screens", path: "/analytics/screens" },
  { label: "Devices", path: "/analytics/devices" },
  { label: "Geography", path: "/analytics/geography" },
  { label: "Sessions", path: "/analytics/sessions" },
  { label: "Errors", path: "/analytics/errors" },
];

const timeRanges = [
  { label: "7 days", value: 7 },
  { label: "30 days", value: 30 },
  { label: "90 days", value: 90 },
];

export function AnalyticsLayout() {
  const { timeRange } = useSnapshot(analyticsStore);
  const location = useLocation();

  return (
    <div className="flex h-full flex-col">
      {/* Fixed Header - stays mounted across route changes */}
      <header className="shrink-0 border-b bg-background">
        <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-bold">Analytics</h1>
          <p className="mt-2 text-muted-foreground">
            Monitor your app usage and performance metrics
          </p>
        </div>

        <div className="mx-auto max-w-7xl px-4 pb-4 sm:px-6 lg:px-8 flex flex-wrap items-center justify-between gap-4">
          <nav
            className="flex gap-1 rounded-lg bg-muted p-1 overflow-x-auto"
            style={{ borderRadius: "var(--radius)" }}
          >
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={cn(
                  "rounded-md px-3 py-1.5 text-sm font-medium transition-colors whitespace-nowrap",
                  location.pathname === item.path
                    ? "bg-background text-foreground shadow-sm"
                    : "text-muted-foreground hover:text-foreground",
                )}
                style={{ borderRadius: "calc(var(--radius) - 2px)" }}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="flex gap-2">
            {timeRanges.map((range) => (
              <button
                key={range.value}
                onClick={() => setTimeRange(range.value)}
                className={cn(
                  "rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
                  timeRange === range.value
                    ? "bg-primary text-primary-foreground"
                    : "bg-muted text-muted-foreground hover:text-foreground",
                )}
                style={{ borderRadius: "var(--radius)" }}
              >
                {range.label}
              </button>
            ))}
          </div>
        </div>
      </header>

      {/* Scrollable Content - only this part changes on navigation */}
      <main className="min-h-0 flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
